import { extensionRequest } from '../../sdk';
export const API = {
    inviteInterpreter(institutionId, data) {
        return extensionRequest({
            endpoint: '/extensions/voyce',
            method: 'POST',
            data,
            queryParams: institutionId && { institutionId },
        });
    },
    getStatusByPreInviteToken(institutionId, { preInviteToken }) {
        return extensionRequest({
            endpoint: `/extensions/voyce/status/preInviteToken/${preInviteToken}`,
            method: 'GET',
            queryParams: institutionId && { institutionId },
        });
    },
    stopInterpreterSession(institutionId, { preInviteToken }) {
        return extensionRequest({
            endpoint: `/extensions/voyce/finish/preInviteToken/${preInviteToken}`,
            method: 'POST',
            queryParams: institutionId && { institutionId },
        });
    },
    async trackInterpreterSession(institutionId, { sessionId, token }) {
        return extensionRequest({
            endpoint: `/extensions/voyce/trackInterpreterSession`,
            method: 'POST',
            data: { sessionId, token },
            queryParams: institutionId != null && { institutionId },
        });
    },
    saveSessionInf(institutionId, data) {
        return extensionRequest({
            endpoint: '/extensions/voyce/statistic',
            method: 'POST',
            data,
            queryParams: institutionId && { institutionId },
        });
    },
    async finishOnDisconnect(institutionId, { preInviteToken }) {
        return extensionRequest({
            endpoint: `/extensions/voyce/finishOnDisconnect/preInviteToken/${preInviteToken}`,
            method: 'POST',
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            queryParams: institutionId && { institutionId },
        });
    },
    async trackInterpreterStatus(token, status, roomId, name) {
        return extensionRequest({
            endpoint: '/extensions/voyce/trackInterpreterStatus',
            method: 'POST',
            data: { token, name, roomId, status },
        });
    },
};
